function getDragEventEntries(evt: DragEvent): FileSystemEntry[] {
    return Array.from(evt.dataTransfer?.items ?? [])
        .filter((item): any => item.kind === 'file')
        .map((item): any => item.webkitGetAsEntry())
        .filter((entry): entry is FileSystemEntry => entry != null);
}

// ----------------------------------------------------------------------------

export default getDragEventEntries;
